import { IconPropsType } from '..';

export const LiveChatIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 20C8.5 16.6863 11.1863 14 14.5 14H20.5C23.8137 14 26.5 16.6863 26.5 20C26.5 23.3137 23.8137 26 20.5 26H14.5L8.5 28V20ZM16.5 21H18.5V19H16.5V21ZM22.5 21H20.5V19H22.5V21ZM12.5 21H14.5V19H12.5V21Z"
      fill="#98A8BA"
    />
    <circle
      cx="30.5"
      cy="10"
      r="2"
      fill="#49A052"
    />
  </svg>
);
